import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";
import {locationsApi} from "@/store/api/v1/locations";

export const settingsApi = createApi({
    reducerPath: "settingsApi",
    tagTypes: ["settings"],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: (build) => ({
        getSettings: build.query({
            query: (data) => ({
                url: api.settings.getSettings(),
                method: "GET",
                params: data,
            }),
            providesTags: ["settings"],
        }),
        updateSettings: build.mutation({
            query: (settings) => {
                const {time_reminder_to_staff, time_reminder_to_user} = settings;

                let convertedTimeReminderToStaff = time_reminder_to_staff;
                if (settings.staff_period === 'days') {
                    convertedTimeReminderToStaff *= 1440;
                } else if (settings.staff_period === 'hours') {
                    convertedTimeReminderToStaff *= 60;
                }

                let convertedTimeReminderToUser = time_reminder_to_user;
                if (settings.user_period === 'days') {
                    convertedTimeReminderToUser *= 1440;
                } else if (settings.user_period === 'hours') {
                    convertedTimeReminderToUser *= 60;
                }
                const updatedSettings = {
                    ...settings,
                    time_reminder_to_staff: convertedTimeReminderToStaff,
                    time_reminder_to_user: convertedTimeReminderToUser,
                };

                return {
                    url: api.settings.updateSettings(),
                    method: "POST",
                    body: updatedSettings,
                };
            },
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(locationsApi.util.invalidateTags(['location']));
                } catch (err) {
                    console.error(err);
                }
            },
            invalidatesTags: ["settings"],
        }),
        updateSettingsBasic: build.mutation({
            query: (data) => ({
                url: api.settings.updateSettings(),
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["settings"],
        }),
    }),
});

export const {
    useGetSettingsQuery,
    useLazyGetSettingsQuery,
    useUpdateSettingsMutation,
    useUpdateSettingsBasicMutation
} = settingsApi;
